/**
 * Renders the main BUIHA logo in top left corner
 * TODO: Waiting for updated version from EI
 */
import { React } from 'react';
import { Link } from 'react-router-dom';

const MainLogo = () => {
  return (
    <Link to="/" className="no-underline">
      <div className="w-44 flex flex-row justify-start items-center">
        <img src="/buiha.png" alt="BUIHA" className="logo w-12 h-12"></img>
        {/* TODO update this */}
        <h2 className="text-3xl font-medium dark-text">BUIHA</h2>
      </div>
    </Link>
  );
};

export default MainLogo;